import React from 'react';
import styles from './ComparisonRangeSelector.module.css';
import DateRangePickerSelect from '@/components/forms/DateRangePicker/DateRangePickerSelect';
import DatePicker from '@/components/forms/DatePicker';
import DateRangeDisplayPicker from '@/components/DateRangeDisplayPicker/DateRangeDisplayPicker';

const ComparisonRangeSelector = ({ 
  currentRange,
  comparisonRange,
  onCurrentRangeChange
}) => {
  const formatDateRange = (startDate, endDate) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const start = new Date(startDate);
    const end = new Date(endDate);
    return `${months[start.getMonth()]} ${start.getDate()}, ${start.getFullYear()}- ${months[end.getMonth()]} ${end.getDate()}, ${end.getFullYear()}`;
  };

  const handleDateRangeChange = (dateRange) => {
    onCurrentRangeChange?.(dateRange);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <span className={styles.comparisonText}>
          {formatDateRange(comparisonRange.from, comparisonRange.to)}
          <span className={styles.compareToText}>
            {` - Compared to`}
          </span>
        </span>
        <div className={styles.datePickerContainer}>
          <DateRangeDisplayPicker
            defaultValue={currentRange}
            onSelectDateRange={handleDateRangeChange} 
          />
        </div>
      </div>
    </div>
  );
};

export default ComparisonRangeSelector;